import React from 'react';
import { IconProps } from '@app/ui/pages/landing-page/header/icon/icon.types';
import { Box, Link } from '@mui/material';
import { IconImage } from '@app/ui/pages/landing-page/header/icon/icon.styles';

export const Icon: React.FC<IconProps> = ({ href, iconUrl }) => {
  return (
    <Box
      width='44px'
      display='flex'
      justifyContent='center'
      alignItems='center'
    >
      <Link href={href}>
        <IconImage src={iconUrl} />
      </Link>
    </Box>
  );
};
